// Import the source module (not the barrel) to match `account-api.ts` — the
// barrel's init graph would create an import cycle for pre-auth modules.
import { hydraUiApi } from '@/services/api/hydra-ui-api';
import { clearSignupAnonymousId, getOrCreateSignupAnonymousId } from './anonymous-id';

/**
 * Stitch the visitor's anonymous pre-auth events to their new user, mirroring
 * Ember's `analytics.alias`: post `{anon_id, user_id}` to the global `alias`
 * endpoint, then discard the anonymous id (it's spent — keeping it would
 * attribute the next visitor on this browser to this user's history).
 *
 * Fired once, right after account creation succeeds. Best-effort: a failed
 * alias only loses event stitching and must never surface in the funnel.
 */
export async function aliasSignupUser(userId: number | string): Promise<void> {
  try {
    await hydraUiApi.tracking.alias({
      body: { anon_id: getOrCreateSignupAnonymousId(), user_id: String(userId) },
    });
  } catch {
    // Best-effort; the account is already created.
  } finally {
    clearSignupAnonymousId();
  }
}
